import init from '@/init'
import { start } from '../vue3/src/init.js'
import { handleAndroidDownload } from '@/utils/androidDownload'

if (!handleAndroidDownload()) {
  init.start()
  start()
}
